'use client';

import { useTranslation } from 'next-i18next';
import { ImageBj } from '@components/common/ImageBj/ImageBj';
import bgImageLeft from '@images/company/offer-bg-left.png';
import bgImageRight from '@images/company/offer-bg-right.png';

/**
 * @description Offer Page Background
 */
export const OfferPageBackground = () => {
  const { t } = useTranslation('common');

  return (
    <div className="absolute z-0 grid h-96 w-full grid-cols-2 bg-gradient-to-b from-[#CFE3F8] to-surface-100">
      <ImageBj
        src={bgImageLeft}
        alt={t('hire.landing.page.meta.title')}
        width={450}
      />
      <ImageBj
        src={bgImageRight}
        alt={t('hire.landing.page.meta.title')}
        width={320}
        className="justify-self-end"
      />
    </div>
  );
};
